import React from 'react'
import Select from "@blocks/Select";
import Grid from '@blocks/Grid';
import Flex from '@blocks/Flex';
import Input from '@blocks/Input';
import EmphasizedContent from '@blocks/EmphasizedContent';

export default function SectionElement({ sections, ...section }: PartialExceptId<Interfaces.SalonJurySection.Includes<"pivot">> & { sections?: Interfaces.Options }) {
    const defaultValue = section.name ? { label: section.name, value: section.id.toString() } : undefined

    return (
        <EmphasizedContent width="100%">
            <Grid gap="15px">
                <Select id={`section-${section.id}`} name={`sections[${section.id}][id]`} background="white" options={sections} value={defaultValue} />
                <Flex justifyContent="flex-start">
                    <Input id={`section-${section.id}-award`} name={`sections[${section.id}][award_ability]`} type="checkbox" label="Grants Awards" checked={section.pivot?.award_ability} />
                </Flex>
            </Grid>
        </EmphasizedContent>
    )
}